import {ApplicationRef, Component, OnInit, ViewChild} from '@angular/core';
import {GroupDatabaseService} from './group-database.service';
import {GroupDatabaseModel, GroupGridRequest} from './group-database.model';
import {GroupGridConfiguration} from '../group-database/group-database.model';
import CustomStore from 'devextreme/data/custom_store';
import {GridResponse} from '../../shared/grid/grid.model';
import {DxDataGridComponent} from 'devextreme-angular';
import {StatisticsGroupModel} from '../../shared/objects/statistics-group.model';

@Component({
  selector: 'app-group-database',
  templateUrl: './group-database.component.html',
  providers: [GroupDatabaseService],
  styleUrls: ['./group-database.component.less']
})
export class GroupDatabaseComponent implements OnInit {
  newVenueFromGroupId: any;
  showGroup = false;
  showVenueProfile = false;
  selectedGroupId: number;
  selectedVenueId: number;

  searchValue: string;

  groupGridConfiguration: GroupGridConfiguration;
  groupGridRequest: GroupGridRequest;
  statisticsGroupModel: StatisticsGroupModel[];

  dataSource: any = {};

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  constructor(private groupDatabaseService: GroupDatabaseService, private appRef: ApplicationRef) {
  }

  ngOnInit() {

    this.groupDatabaseService.getGroupDatabaseAnalytics()
      .subscribe(
        (response) => {
          this.statisticsGroupModel = response;
        },
        (error) => console.log(error)
      );

    this.groupGridConfiguration = new GroupGridConfiguration();
    this.groupGridConfiguration.dataGrid = this.dataGrid;
    this.groupGridConfiguration.service = this.groupDatabaseService;
    this.groupGridRequest = new GroupGridRequest();

    const component = this;
    const conf = this.groupGridConfiguration;

    this.dataSource.store = new CustomStore({
      load: function (loadOptions) {

        conf.mapGridRequest(component.groupGridRequest, loadOptions);

        return component.groupGridConfiguration.service.getData(component.groupGridRequest)
          .toPromise()
          .then((response: GridResponse) => {

            return {
              data: response.rows,
              totalCount: response.totalCount
            };
          })
          .catch(error => {
            throw new Error(error);
          });
      }
    });


  }

  showGroupById(id) {
    this.showVenueProfile = false;
    this.selectedGroupId = id;
    this.showGroup = true;
  }

  showVenueById(venueId) {
    this.selectedVenueId = venueId;
    this.showVenueProfile = true;
  }

  expandGroup(event, group) {
    event.stopPropagation();
    group.data.show = !group.data.show;

    if (!group.data.show && group.data.venues.length > 0) {
      group.data.venues.forEach((venue) => {
        venue.show = false;
      });
    }

  }

  expandVenue(event, venue) {
    event.stopPropagation();
    venue.show = !venue.show;
  }

  newGroup() {
    this.selectedGroupId = null;
    this.showGroup = true;
  }

  search(value) {
    this.groupGridConfiguration.customSearch[0].value = value;
    this.groupGridConfiguration.dataGrid.instance.getDataSource().reload();
  }

  closeCreateGroup(id) {
    this.showGroup = false;

    if (id) {
      this.groupGridConfiguration.refreshGrid();
      setTimeout(() => {
        this.showGroupById(id);
      });
    }
    this.groupGridConfiguration.refreshGrid();
  }

  venueChanged(refresh) {
    this.showVenueProfile = false;
    this.showGroup = false;
    if (refresh) {
      this.groupGridConfiguration.refreshGrid();
    }
  }

  switchShownVenue(venueId) {
    this.showVenueProfile = false;
    this.showGroup = false;
    this.appRef.tick();
    this.showVenueById(venueId);
  }

  newVenue(groupId) {
    this.showVenueProfile = false;
    this.showGroup = false;

    this.newVenueFromGroupId = groupId;
    this.appRef.tick();
    this.showVenueById(null);
  }

  exportToExcel() {
    this.groupGridConfiguration.dataGrid.instance.exportToExcel(false);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/group-database/group-database.component.ts